import React from 'react'
import { Helmet } from 'react-helmet'
import { Outlet } from 'react-router-dom'

import PageContainer from 'components/common/PageContainer'
import { ConfigurationsBreadcrumbs } from 'components/configurations/ConfigurationsBreadcrumbs'
import { Header } from 'components/navigation/Header'

export const ConfigurationsIndexRoutesWrapper: React.FC = () => {
  return (
    <>
      <Helmet title="Configurations" />
      <Header>
        <ConfigurationsBreadcrumbs />
      </Header>
      <PageContainer>
        <Outlet />
      </PageContainer>
    </>
  )
}
